(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var dot, ring;
  var mouseX = -100, mouseY = -100;
  var dotX = -100, dotY = -100;
  var ringX = -100, ringY = -100;
  var active = false;

  var HOVER_SELECTOR =
    'a, button, input[type="submit"], input[type="button"], .product-card, ' +
    '.collection-card, [role="button"], .swatch, select, .quick-add__button, ' +
    'summary, [on\\:click]';

  function createCursor() {
    dot = document.createElement('div');
    dot.className = 'viking-cursor';
    ring = document.createElement('div');
    ring.className = 'viking-cursor-ring';
    document.body.appendChild(ring);
    document.body.appendChild(dot);
    document.documentElement.classList.add('viking-custom-cursor-active');
  }

  function onMouseMove(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
    if (!active) {
      active = true;
      dot.classList.add('is-active');
      ring.classList.add('is-active');
    }
  }

  function onMouseLeaveWindow() {
    active = false;
    dot.classList.remove('is-active');
    ring.classList.remove('is-active');
  }

  function onPointerOver(e) {
    var target = e.target && e.target.closest ? e.target.closest(HOVER_SELECTOR) : null;
    if (target) {
      dot.classList.add('is-hovering');
      ring.classList.add('is-hovering');
    }
  }

  function onPointerOut(e) {
    var target = e.target && e.target.closest ? e.target.closest(HOVER_SELECTOR) : null;
    if (target) {
      dot.classList.remove('is-hovering');
      ring.classList.remove('is-hovering');
    }
  }

  function tick() {
    dotX += (mouseX - dotX) * 0.35;
    dotY += (mouseY - dotY) * 0.35;
    ringX += (mouseX - ringX) * 0.16;
    ringY += (mouseY - ringY) * 0.16;

    dot.style.transform = 'translate3d(' + dotX + 'px,' + dotY + 'px,0)';
    ring.style.transform = 'translate3d(' + ringX + 'px,' + ringY + 'px,0)';

    requestAnimationFrame(tick);
  }

  function initCartBubblePop() {
    var countEl = document.querySelector('.cart-bubble__text-count');
    if (!countEl) return;
    var lastValue = countEl.textContent.trim();
    var observer = new MutationObserver(function () {
      var newValue = countEl.textContent.trim();
      if (newValue !== lastValue) {
        lastValue = newValue;
        var bubble = countEl.closest('.cart-bubble');
        if (bubble) {
          bubble.classList.remove('viking-bubble-pop');
          // Force reflow so the animation can retrigger on rapid consecutive adds
          void bubble.offsetWidth;
          bubble.classList.add('viking-bubble-pop');
        }
      }
    });
    observer.observe(countEl, { childList: true, characterData: true, subtree: true });
  }

  function init() {
    createCursor();
    document.addEventListener('mousemove', onMouseMove, { passive: true });
    document.addEventListener('mouseover', onPointerOver, { passive: true });
    document.addEventListener('mouseout', onPointerOut, { passive: true });
    document.documentElement.addEventListener('mouseleave', onMouseLeaveWindow, { passive: true });
    requestAnimationFrame(tick);
    initCartBubblePop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
